import http from "@core/fetch";
import { components } from "@apiSchema";
import { useData } from "@hooks/useData";

type Response = components["schemas"]["LatestNewsAndPublicationsWrapper"];

const DEFAULT_DATA: Response = {
    publications: [],
    news: [],
};

async function getHomeReports(tags: number[]): Promise<Response> {
    const response = await http.post('get home reports and news', {}, {
        body: JSON.stringify(tags),
        headers: {
            'content-type': 'application/json; charset=utf-8',
        },
    });

    return response as Response;
}

export function useHomeReportsAndNews(tags: number[] = []) {
    return useData(DEFAULT_DATA, getHomeReports, tags);
}
